export default __webpack_public_path__ + "./images/flag.e2a18ce9.svg";